import {db } from "../../firebase";

export const toggleBooleans = async({payload,user_id}:{user_id:string, payload:{name:string,value:boolean}}) => {
    db.collection("jobseekers").doc(user_id).set({ [payload.name]: payload.value } ,{merge:true})
}
